<div class="dialog-header">
  <button mat-icon-button (click)="cerrarDialogo()">
    <mat-icon>close</mat-icon>
  </button>
</div>
<app-detalle-tgr [formularioTGR]="'true'"></app-detalle-tgr>